import React, { useState, useEffect, useRef } from 'react'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import inputErrors from '../../helpers/validation'
import { Container, Row } from 'react-bootstrap'
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import './event.css'
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux'
import { createEvent, clearError } from '../../../redux/reducers/eventSlice';
import { useNavigate } from 'react-router-dom'
import { snackbarContext } from '../../helpers/Snakbar'
import MapInput from './MapInput';
import { clearUser } from '../../../redux/reducers/authSlice';
import Navbar from '../../helpers/Navbar';
import { TabTitle } from '../../helpers/GeneralFunctions';
import Loader from '../../helpers/Loader';
import Footer from '../../helpers/Footer';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import InfoIcon from '@mui/icons-material/Info';

const EVENT_DETAILS_FIELDS = [
    "eventName",
    "eventDate",
    "eventTime",
    "eventTheme",
    "eventAddress",
    "eventInfo"
];

const CreateEvent = () => {
  const formRef = useRef(null);
  TabTitle("Create Event")
  const setStateSnackbarContext = React.useContext(snackbarContext)
  const { error: backendError, loading } = useSelector((state) => state.event)
  const { hasEnded, userCode,demoVersion,demoExpiryTime,needsDate,inviteTimeExpired } = useSelector((state) => state.auth.user)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [values, setValues] = useState({
    eventName: "",
    eventDate: getCurrentDate(),
    eventTime: "",
    eventTheme: "",
    eventInfo: "",
    eventAddress: "",
    gLocation: {
      latitude: "",
      longitude: "",
      formatted_address: ""
    },
    group: []
  })

  const [time, setTime] = useState();
  const [isSubmitting, setSubmitting] = useState(false);
     const [showEventDateWarning, setShowEventDateWarning] = useState(false);
  const [errors, setErrors] = useState({});
  function getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
const now = new Date().getTime();
const expiryTime = new Date(demoExpiryTime).getTime();
const isDemoExpired =expiryTime && now > expiryTime;

 
  const handleChange = (event) => {
    setValues({
            ...values,
            [event.target.name]: event.target.value
        });
     if (event.target.name === "eventDate") {
    setShowEventDateWarning(false);
  }
  }
  const handleTimeChange = (newTime) => {
    const hours = dayjs(newTime).format('hh:mm A');
    setValues(() => ({
      ...values,
      eventTime: hours
    }));
  }



  const addEvent = () => {
    setSubmitting(false)
    dispatch(createEvent({ values, navigate, setStateSnackbarContext}))
  }

 

  const renderTrialDateWarning = (selectedDate) => {
  if (!selectedDate || !demoExpiryTime) {
    return null;
  }

  const trialExpiry = new Date(demoExpiryTime);
  const selected = new Date(selectedDate);

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
    });
  };

  return (
    <div className="trial-date-warning">
      <div className="trial-date-warning-icon">
        ⓘ
      </div>

      <div className="trial-date-warning-content">

        <div className="trial-date-warning-title">
          This date is within the trial period.
        </div>

        <div className="trial-date-warning-text">
          Your free trial ends on{" "}
          <strong>{formatDate(trialExpiry)}</strong>.
        </div>

        <div className="trial-date-warning-text">
          To use <strong>{formatDate(selected)}</strong>, upgrade your invite.
        </div>

        <div className="trial-date-warning-hint">
          You can continue your trial by choosing a date after{" "}
          {formatDate(trialExpiry)}.
        </div>

      </div>
    </div>
  );
};

  useEffect(() => {

    if (isSubmitting) {
      const noErrors = Object.keys(errors).length === 0;
      if (noErrors) {
        addEvent()
      } else {
        formRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }

    if (backendError === "session expired") {
      setStateSnackbarContext(true, "session expired please login again", "error");
      dispatch(clearError());
      dispatch(clearUser())
      navigate("/login")
    } else if (backendError) {
      setStateSnackbarContext(true, backendError, "error");
      dispatch(clearError());
    }



  }, [isSubmitting, errors, backendError])



  if (hasEnded) {
    window.location.href = "/display/notfound";
  }


  const handleSubmit = (e) => {
    e.preventDefault()
     const validationErrors = inputErrors(
            values,
            EVENT_DETAILS_FIELDS
        );

        setErrors(validationErrors)

           if (Object.keys(validationErrors).length > 0) {
                 return
               }
    if(demoVersion && values.eventDate < demoExpiryTime){
      setShowEventDateWarning(true); return; 
    }

    setSubmitting(true)
  }

   useEffect(() => {
  if (isDemoExpired) {
    navigate("/");
  }
}, [isDemoExpired, navigate]);

 useEffect(() => {
  if (inviteTimeExpired) {
    navigate("/");
  }
}, [inviteTimeExpired, navigate]);

   useEffect(() => {
  if (needsDate) {
    navigate("/");
  }
}, [needsDate, navigate]); 
  if (loading) {
    return <Loader />
  }


  return (
    <>
      <Navbar />
      <Container>
        <Row className='justify-content-center px-2'>
        
          <div className={`col-lg-8 col-md-11 event-container ${demoVersion?"demo-e-padding":"e-normal-padding"}`}>
            <h3 className='event-form-heading'>Add New Event</h3>
            <form onSubmit={handleSubmit} className='event-form' ref={formRef}>
              
              <div className={errors.eventName ? "input-div-error" : "input-div"}  >
                <input type="text"
                  name="eventName"
                  value={values.eventName}
                  onChange={handleChange}
                  placeholder=' '
                  className='input-field' />
                <label>Event Name <span style={{ color: "red" }}> * </span>  <span className='label-hide'>(e.g. Mehendi,Reception)
  </span></label>
              </div>
              {/* <div className='mb-3'>  {errors.eventName && (<small className="error-msg">{errors.eventName}</small>)} </div> */}

              {/* <div className='row align-items-center'> */}
                 <span className='event-label-text'>Event Date <span style={{ color: "red" }}> * </span> </span>
                {/* <div className="col-sm-6"> */}
                  <input
                    type="date"
                    id="datePicker"
                    name='eventDate'
                    value={values.eventDate}
                    onChange={handleChange}
                    // min={getCurrentDate()} 
                    required
                    className='date-input'
                  />
        <div >  {errors.eventDate && (<small className="error-msg">{errors.eventDate}</small>)} 
        
        </div>
          {showEventDateWarning &&  <div style={{marginTop:"10px"}}>{renderTrialDateWarning(values.eventDate)}</div> }
         
                {/* </div> */}

                {/* <div className='col-sm-6'> */}
                    <span className='event-time-text'>Event Time <span style={{ color: "red" }}> * </span></span>
                  <LocalizationProvider dateAdapter={AdapterDayjs}  >
                    <DemoContainer components={['TimePicker']} className="time-container">
                      <TimePicker
                        label="Event time"
                        className='time-input'
                        name={errors.eventTime ? "time-input-error" : "time-input"}
                        value={time}
                        onChange={handleTimeChange}
                        required
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                  <div className='mb-3'>  {errors.eventTime && (<small className="error-msg">{errors.eventTime}</small>)} </div>
                {/* </div> */}
                  {/* </div> */}
                       <div className={errors.eventAddress ? "input-div-error" : "input-div"}>
                <input type="adress"
                  className='input-field'
                  name="eventAddress"
                  value={values.eventAddress}
                  onChange={handleChange}
                  placeholder=' ' />
                <label>Venue Name(Optional) <span className='label-hide'>(e.g. Shagun Palace)</span></label>
              </div>
              <div className='mb-3'>  {errors.eventAddress && (<small className="error-msg">{errors.eventAddress}</small>)} </div>


       <div className={errors.eventTheme ? "input-div-error" : "input-div"} >
                <input type="text"
                  placeholder=' '
                  name="eventTheme"
                  value={values.eventTheme}
                  onChange={handleChange}
                  className='input-field' />
                <label>Dress Code (Optional) <span className='label-hide'>(e.g. Black Kurta, Pink Saree)</span></label>
              </div>
              <div className='mb-3'>  {errors.eventTheme && (<small className="error-msg">{errors.eventTheme}</small>)} </div>       
             
       
        <span className='event-details-text'>Event Details (Optional)</span>
              <textarea
                name="eventInfo"
                className={errors.eventInfo ? "textarea-error" : "info-textarea"}
                value={values.eventInfo}
                cols="30"
                rows="3"
                onChange={handleChange}
                placeholder='  Add any other information for your guests'></textarea>
              <div className='mb-3'>  {errors.eventInfo && (<small className="error-msg">{errors.eventInfo}</small>)} </div>
             
             
              <div>

                 <span className='event-details-text'>Event Location (Optional)
 {/* (<GpsFixedIcon style={{ fontSize: "16px" }} /> For Fetching Current Location) */}
                  <OverlayTrigger placement="auto" overlay={
                    <Tooltip id="tooltip-gmaps"> <span style={{ textAlign: "justify", }}> This location is used to show Google Maps directions to your guests.
 <br /> </span></Tooltip>
                  }>
                    <InfoIcon className='tooltip-icon' />
                  </OverlayTrigger>
                 </span>
                      <span className="location-info">
    Search and select the event location so guests can get directions from your invitation.
  </span> 
                <MapInput setValues={setValues} values={values} />
                <span className='google-location-heper-text'>Can't find the place? Use <GpsFixedIcon/> for current location</span>
              </div>
               
              <button className='event-submit-button' type='submit'>Add Event</button>
            </form>
          </div>
        </Row>
      </Container>
      <Footer userCode={userCode} />
    </>
  )
}

export default CreateEvent